module.exports = __webpack_public_path__ + "img/badge_refazi_mess_interna.05ac8746.jpg";